(function () {
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var wide = window.matchMedia('(min-width: 750px)');

  var TEXT_SELECTOR = 'h1, h2, h3, h4, h5, p, li, blockquote, .button';
  var IMAGE_SELECTOR = 'img';
  // Les sections d'un template JSON ont un id de la forme shopify-section-template--123__cle : on cible donc par la fin de l'id ([id$=...])
  var PARALLAX_EXCLUDE = `.product-card, product-card, .card-gallery, .caucasus-swipe-item, .bsd__img, #shopify-section-section_notre_histoire, [id$='__section_notre_histoire'], img[src*='photo-1577701122197'], [id$='__slideshow_caucasus']`;

  var scrollers = [];
  var parallaxItems = [];
  var ticking = false;
  var progressBar = null;
  var progressTicking = false;
  var autoplayStarted = false;

  function clamp(value, min, max) {
    return Math.max(min, Math.min(max, value));
  }

  function debounce(fn, wait) {
    var timer;
    return function () {
      clearTimeout(timer);
      timer = setTimeout(fn, wait);
    };
  }

  // Sens d'entree (ecrans larges) : colonne gauche depuis la gauche, colonne droite depuis la droite
  function setDirection(el) {
    if (!wide.matches) return;
    var r = el.getBoundingClientRect();
    if (!r.width || !r.height) return;
    var center = (r.left + r.width / 2) / window.innerWidth;
    if (center < 0.4) {
      el.setAttribute('data-reveal', 'left');
    } else if (center > 0.6) {
      el.setAttribute('data-reveal', 'right');
    }
  }

  function markText(el, index) {
    el.classList.add('caucasus-reveal');
    el.style.transitionDelay = (Math.min(index % 8, 7) * 110) + 'ms';
    setDirection(el);
  }

  function markImage(el) {
    el.classList.add('caucasus-reveal-img');
  }

  // Titres h1 / h2 en texte simple : reveal mot par mot (chaque mot monte depuis un masque)
  function splitHeadings(main) {
    var result = [];
    var heads = main.querySelectorAll('h1, h2');
    heads.forEach(function (el) {
      if (el.children.length > 0) return;
      var text = (el.textContent || '').trim();
      if (!text || text.length > 60) return;
      var words = text.split(' ').filter(function (w) {
        return w.length > 0;
      });
      el.setAttribute('aria-label', text);
      el.textContent = '';
      words.forEach(function (word, i) {
        var outer = document.createElement('span');
        outer.className = 'caucasus-word';
        outer.setAttribute('aria-hidden', 'true');
        var inner = document.createElement('span');
        inner.className = 'caucasus-word-inner';
        inner.textContent = word;
        inner.style.transitionDelay = (i * 90) + 'ms';
        outer.appendChild(inner);
        el.appendChild(outer);
        if (i < words.length - 1) el.appendChild(document.createTextNode(' '));
      });
      el.classList.add('caucasus-split');
      result.push(el);
    });
    return result;
  }

  // Carrousels / zones qui se swipent : detectes automatiquement (defilement horizontal reel)
  function detectSwipers(main) {
    var nodes = main.querySelectorAll('div, ul, ol, slideshow-slides');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (el.hasAttribute('data-caucasus-swipe')) continue;
      if (el.children.length < 2) continue;
      var overflowX = window.getComputedStyle(el).overflowX;
      if (overflowX !== 'auto' && overflowX !== 'scroll') continue;
      if (el.scrollWidth <= el.clientWidth + 8) continue;
      el.setAttribute('data-caucasus-swipe', '');
      el.classList.add('caucasus-swipe');
      Array.prototype.forEach.call(el.children, function (child) {
        child.classList.add('caucasus-swipe-item');
      });
      scrollers.push(el);
    }
  }

  // Carrousel des avis : defilement automatique doux, mis en pause des que le visiteur interagit
  function setupAutoplay() {
    if (autoplayStarted) return;
    var section = document.querySelector(`[id$='__avis_clients_section']`) || document.getElementById('shopify-section-avis_clients_section');
    if (!section) return;
    var scroller = section.querySelector('[data-caucasus-swipe]');
    if (!scroller) return;
    autoplayStarted = true;

    var hovering = false;
    var lastInteraction = 0;
    var markInteraction = function () {
      lastInteraction = Date.now();
    };
    ['touchstart', 'pointerdown', 'wheel', 'keydown', 'focusin'].forEach(function (name) {
      scroller.addEventListener(name, markInteraction, { passive: true });
    });
    scroller.addEventListener('mouseenter', function () {
      hovering = true;
    });
    scroller.addEventListener('mouseleave', function () {
      hovering = false;
      markInteraction();
    });

    setInterval(function () {
      if (document.hidden || hovering) return;
      if (Date.now() - lastInteraction < 8000) return;
      var rect = scroller.getBoundingClientRect();
      if (rect.bottom < 0 || rect.top > window.innerHeight) return;
      var first = scroller.children[0];
      if (!first) return;
      var styles = window.getComputedStyle(scroller);
      var gap = parseFloat(styles.columnGap) || parseFloat(styles.gap) || 0;
      var step = first.offsetWidth + gap;
      var max = scroller.scrollWidth - scroller.clientWidth;
      var next = scroller.scrollLeft + step;
      scroller.scrollTo({ left: next > max - 4 ? 0 : next, behavior: 'smooth' });
    }, 4500);
  }

  // Zoom lent : filet de securite. Si la feuille de style n'a pas demarre l'animation de zoom sur
  // l'image (selecteur qui ne correspond pas), on la lance ici avec l'API Web Animations.
  function ensureZoom(imgs, animationName, keyframes, duration, roundFrame) {
    imgs.forEach(function (img) {
      if (img.hasAttribute('data-zoom-' + animationName)) return;
      if (!img.animate) return;
      var running = img.getAnimations
        ? img.getAnimations().filter(function (a) {
            return a.animationName === animationName;
          })
        : [];
      if (running.length > 0) return;
      img.setAttribute('data-zoom-' + animationName, '');
      var frame = img.parentElement;
      if (frame && roundFrame) {
        frame.style.overflow = 'hidden';
        frame.style.borderRadius = '24px';
      }
      img.style.transformOrigin = '50% 50%';
      img.animate(keyframes, { duration: duration, iterations: Infinity, direction: 'alternate', easing: 'ease-in-out' });
    });
  }

  function zoomFallbacks(main) {
    ensureZoom(
      main.querySelectorAll(`[id$='__section_notre_histoire'] img, #shopify-section-section_notre_histoire img, img[src*='photo-1577701122197']`),
      'caucasus-histoire-zoom',
      [
        { transform: 'scale(1) translate3d(0, 0, 0) rotate(0deg)' },
        { transform: 'scale(1.6) translate3d(-5%, -3%, 0) rotate(1.2deg)' }
      ],
      32000,
      true
    );
    ensureZoom(
      main.querySelectorAll(`[id$='__slideshow_caucasus'] img`),
      'caucasus-hero-zoom',
      [
        { transform: 'scale(1) translate3d(0, 0, 0)' },
        { transform: 'scale(1.35) translate3d(-3%, -2%, 0)' }
      ],
      14000,
      false
    );
  }

  // Images dans un cadre qui rogne (overflow hidden) : zoom + parallaxe au scroll
  function findClip(img, main) {
    var parent = img.parentElement;
    for (var i = 0; i < 4 && parent && parent !== main; i++) {
      var overflow = window.getComputedStyle(parent).overflow;
      if (overflow === 'hidden' || overflow === 'clip') return parent;
      parent = parent.parentElement;
    }
    return null;
  }

  function collectParallax(main) {
    var imgs = main.querySelectorAll('.shopify-section img');
    for (var i = 0; i < imgs.length; i++) {
      var img = imgs[i];
      if (img.classList.contains('caucasus-parallax')) continue;
      if (img.closest(PARALLAX_EXCLUDE)) continue;
      var clip = findClip(img, main);
      if (!clip || clip.offsetHeight < 160) continue;
      img.classList.add('caucasus-parallax');
      parallaxItems.push({ img: img, clip: clip });
    }
  }

  function updateSwipers() {
    var vh = window.innerHeight;
    scrollers.forEach(function (scroller) {
      var rect = scroller.getBoundingClientRect();
      if (!rect.width || rect.bottom < 0 || rect.top > vh) return;
      var center = rect.left + rect.width / 2;
      Array.prototype.forEach.call(scroller.children, function (item) {
        var r = item.getBoundingClientRect();
        var dx = Math.abs(r.left + r.width / 2 - center) / rect.width;
        var strength = clamp((dx - 0.3) / 0.25, 0, 1);
        item.style.setProperty('--sw', strength.toFixed(3));
      });
    });
  }

  function updateParallax() {
    var vh = window.innerHeight;
    parallaxItems.forEach(function (item) {
      var r = item.clip.getBoundingClientRect();
      if (r.bottom < -50 || r.top > vh + 50 || !r.height) return;
      var t = clamp(((r.top + r.height / 2) - vh / 2) / (vh / 2 + r.height / 2), -1, 1);
      var s = 1.1 + 0.05 * (1 - Math.abs(t));
      var y = -t * ((s - 1) / 2) * r.height * 0.9;
      item.img.style.scale = s.toFixed(4);
      item.img.style.translate = '0 ' + y.toFixed(1) + 'px';
    });
  }

  function update() {
    ticking = false;
    updateSwipers();
    updateParallax();
  }

  function schedule() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(update);
  }

  // Barre de progression de lecture en haut de page (toutes les pages)
  function updateProgress() {
    progressTicking = false;
    if (!progressBar) return;
    var root = document.scrollingElement || document.documentElement;
    var rootMax = root.scrollHeight - root.clientHeight;
    var progress = rootMax > 0 ? root.scrollTop / rootMax : 0;
    var wrapper = document.querySelector('.page-wrapper');
    if (wrapper) {
      var wrapperMax = wrapper.scrollHeight - wrapper.clientHeight;
      if (wrapperMax > 2) progress = Math.max(progress, wrapper.scrollTop / wrapperMax);
    }
    progressBar.style.transform = 'scaleX(' + clamp(progress, 0, 1).toFixed(4) + ')';
  }

  function setupProgress() {
    if (document.querySelector('.caucasus-progress')) return;
    progressBar = document.createElement('div');
    progressBar.className = 'caucasus-progress';
    progressBar.setAttribute('aria-hidden', 'true');
    document.body.appendChild(progressBar);
    var request = function () {
      if (progressTicking) return;
      progressTicking = true;
      window.requestAnimationFrame(updateProgress);
    };
    document.addEventListener('scroll', request, { passive: true, capture: true });
    window.addEventListener('resize', request);
    request();
  }

  function init() {
    if (reduceMotion) return;

    setupProgress();

    var main = document.getElementById('MainContent');
    // Autres animations : uniquement sur la page d'accueil (data-template vient de layout/theme.liquid)
    if (!main || main.dataset.template !== 'index') return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var target = entry.target;
          target.classList.add('is-visible');
          observer.unobserve(target);
          // Le delai d'echelonnement ne doit servir qu'a l'entree, pas aux effets de swipe / survol
          if (target.style.transitionDelay) {
            setTimeout(function () {
              target.style.transitionDelay = '';
            }, 2000);
          }
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -6% 0px' }
    );

    var splitEls = splitHeadings(main);
    splitEls.forEach(function (el) {
      observer.observe(el);
    });

    var textEls = main.querySelectorAll(TEXT_SELECTOR);
    textEls.forEach(function (el, i) {
      if (el.classList.contains('caucasus-split')) return;
      markText(el, i);
      observer.observe(el);
    });

    var imageEls = main.querySelectorAll(IMAGE_SELECTOR);
    imageEls.forEach(function (el) {
      markImage(el);
      observer.observe(el);
    });

    function refresh() {
      detectSwipers(main);
      collectParallax(main);
      setupAutoplay();
      zoomFallbacks(main);
      schedule();
    }

    refresh();
    window.addEventListener('load', refresh);
    window.addEventListener('resize', debounce(refresh, 200));
    setTimeout(refresh, 1500);
    // Le zoom du hero demarre apres l'animation d'entree (environ 3 s) : on verifie une derniere fois ensuite
    setTimeout(refresh, 4200);

    // capture: attrape aussi le defilement horizontal des carrousels (le scroll ne remonte pas)
    document.addEventListener('scroll', schedule, { passive: true, capture: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
